function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M129.4,130.7H44.2c-1.7,0-3.1-1.4-3.1-3.1V71c0-1.7,1.4-3.1,3.1-3.1h85.1c1.7,0,3.1,1.4,3.1,3.1v56.5 C132.5,129.3,131.1,130.7,129.4,130.7z M45.8,126h82V72.6h-82V126z"
}), React.createElement("path", {
  className: "st0",
  d: "M36.8,84H22.6c-1.7,0-3.1-1.4-3.1-3.1V24.3c0-1.7,1.4-3.1,3.1-3.1h85.1c1.7,0,3.1,1.4,3.1,3.1v39.9h-4.7V25.9 h-82v53.4h12.6V84z"
}), React.createElement("path", {
  className: "st0",
  d: "M45.6,128.5l-4.3-1.9l17.8-39.8c0.5-1.1,1.5-1.8,2.7-1.8c1.1-0.1,2.3,0.5,2.9,1.5L75.8,105h4.5l8.8-14.4 c0.6-0.9,1.6-1.5,2.7-1.5c0,0,0,0,0.1,0c1.1,0,2.1,0.6,2.7,1.6l12.6,22.4l23,0.2l0,4.7l-23.4-0.2c-1.4,0-2.7-0.8-3.4-2L91.8,95.4 l-7.7,12.5c-0.7,1.2-2,1.9-3.4,1.9h-5.4c-1.4,0-2.7-0.7-3.4-1.9l-9.9-16.3L45.6,128.5z"
}), React.createElement("rect", {
  x: 6.3,
  y: 49.5,
  transform: "matrix(0.4001 -0.9165 0.9165 0.4001 -25.6829 64.4675)",
  className: "st0",
  width: 60.2,
  height: 4.7
}), React.createElement("polygon", {
  className: "st0",
  points: "50.3,62.6 45.2,62.6 62,24.1 66.3,25.9  "
}), React.createElement("polygon", {
  className: "st0",
  points: "80.4,62.6 75.2,62.6 92.1,24.1 96.4,25.9  "
}), React.createElement("polygon", {
  className: "st0",
  points: "95,62.6 89.9,62.6 106.7,24.1 107.9,33  "
}));

var SvgAssistanceIcon = function SvgAssistanceIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAssistanceIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assistance-icon.bf03c7e6.svg";
export { ForwardRef as ReactComponent };